var $pageTimeout,
    $modalTimeout;

$(function () {
    // https://www.quirksmode.org/js/cookies.html
    function readCookie(name)
    {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i=0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') {
                c = c.substring(1,c.length);
            }
            if (c.indexOf(nameEQ) == 0) {
                return c.substring(nameEQ.length,c.length);
            }
        }
        return null;
    }


    // don't do anything if the cookie is set
    // have to check here as well as the PHP for footer ribbon submission
    if (readCookie('leave_success')) {
        return false;
    }

    // grab the modal markup...
    $.get('/tools/leave/modal', function (data) {

        // ...and append to the body
        $('body').append(data);

        $pageTimeout = setTimeout(function () {
            //console.log('allow mouse');

            // set the listener for the mouse out on html
            $('html').on('mouseleave', function (e) {
                //console.log(e);

                // if dismissed don't show this session
                if (readCookie('leave_dismissed')) {
                    return false;
                }

                // ensure that the pop up isn't fired on certain elements i.e. selects, autocompletes
                var exclude = ['select', 'input'],
                    target = e.target.tagName.toLowerCase();

                if ($.inArray(target, exclude) !== -1) {
                    return;
                }

                // Below logic https://github.com/beeker1121/exit-intent-popup
                // Get the current viewport width.
                var vpWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

                // If the current mouse X position is within 20px of the right edge
                // of the viewport, return.
                if (e.clientX >= (vpWidth - 20)) {
                    return;
                }

                // If the current mouse Y position is not within 50px of the top
                // edge of the viewport, return.
                if (e.clientY >= 50) {
                    return;
                }

                // Reliable, works on mouse exiting window and
                // user switching active program
                var from = e.relatedTarget || e.toElement;

                if (!from && !$('#global-leave-modal').is(':visible')) {
                    $modalTimeout = setTimeout(function () {
                        $('#global-leave-modal').modal('show');
                    }, 500);
                }
            });

            $('html').on('mouseenter', function (e) {
                clearTimeout($modalTimeout);
            });

        }, 5000);

        var modal = $('#global-leave-modal');

        // replace fancy inputs, isn't done when an element is hidden
        modal.one('shown.bs.modal', function () {
            jcf.customForms.replaceAll();
        });

        // data layer tracking events
        modal.on('show.bs.modal', function () {
            if (typeof dataLayer !== 'undefined') {
                dataLayer.push({event: 'leave-modal-display'});
            }
        });
        modal.on('hide.bs.modal', function () {
            if (typeof dataLayer !== 'undefined') {
                dataLayer.push({event: 'leave-modal-close'});
            }

            // dismiss cookie -- 30 days
            var date = new Date();
            date.setTime(date.getTime()+(30*24*60*60*1000));
            var expires = "expires="+date.toGMTString();

            document.cookie = 'leave_dismissed=1;' + expires + ';path=/';
        });

        // we will need to hijack the submit to handle within the modal
        modal.on('submit', 'form', function (e) {
            e.preventDefault();

            // disable the submit button to prevent multiple tries
            $('#leave-submit').prop('disabled', 'disabled');

            var formData = $(this).serialize(),
                formWrap = $('#global-leave-modal').find('.warm-leads-form');

            // post for validation
            $.post('/tools/leave/modal', formData, function (data) {
                var responseWrap = $(data).find('.warm-leads-form');

                // ensure we allow the submit button to be used again
                $('#leave-submit').removeProp('disabled');

                // only act if we have a response
                if (responseWrap.length) {
                    // replace the form wrap with the returned mark up, be it success or fail
                    formWrap.remove();
                    $('#global-leave-modal').find('.modal-body').append(responseWrap);
                    jcf.customForms.replaceAll();

                    // disable modal if no form returned i.e. success
                    var returnForm = $(data).find('.warm-leads-form form');
                    if (!returnForm.length) {
                        $('html').off('mouseleave');
                    }
                }
            });
        });
    });
});